
import { Component, Input, OnInit } from '@angular/core';
import { Utils } from '@serasa/shared/utils/utils';

@Component({
    selector: 'pl-me',
    templateUrl: 'me.component.html',
    styleUrls: ['me.component.scss'],
    imports: []
})
export class MeComponent implements OnInit {

    @Input() user = '';
    
    public show = false;

    ngOnInit() {
        this.show = false;
        if (this.user) {
            this.show = this._isSameUser(this.user);
        }
    }

    private _isSameUser(logon: string): boolean {
        const userLogon = Utils.decodeToken(Utils.getCookie("accessToken"));
        return userLogon?.logon?.toUpperCase() === logon.toUpperCase();
    }
}